import { render, staticRenderFns } from "./Inventory.vue?vue&type=template&id=1b43cff6&scoped=true&"
import script from "./Inventory.vue?vue&type=script&lang=js&"
export * from "./Inventory.vue?vue&type=script&lang=js&"
import style0 from "./Inventory.vue?vue&type=style&index=0&id=1b43cff6&prod&scoped=true&lang=scss&"
import style1 from "./Inventory.vue?vue&type=style&index=1&id=1b43cff6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b43cff6",
  null
  
)

export default component.exports